<template>
  <div class="scene signup flex-r">
    <div class="section size-50" />

    <div id="step-container" class="size-40">
      <div class="signup-form-bg shadow-large">
        <h1 class="ff-mrgn-b-60">
          Выберите удобный для Вас способ оплаты подписки:
        </h1>

        <div class="jrm-method-changer">
          <PaymentMethod
            v-for="paymentMethod in paymentMethods"
            :key="paymentMethods.handle"
            :payment-method="paymentMethod"
            :payment-credentials-method="paymentCredentials.method"
            @click.native="setPaymentMethod(paymentMethod)"
          />
        </div>

        <template v-if="paymentCredentials.method === paymentMethodsHandle.BANK_CARD">
          <BankCardTypePicker
            v-model="paymentCredentials.isTermsOfPaymentConfirmed"
            :payment-credentials-bank-card-types="paymentCredentialsBankCardTypes"
            :selected-payment-credentials-bank-card-types="paymentCredentials.bankCardType"
            @setPaymentCredentialsType="setPaymentCredentialsType"
          />

          <BankCardPaymentForm
            ref="creditCard"
            v-model="paymentCredentials.creditCard"
            :is-active="!paymentCredentials.isTermsOfPaymentConfirmed"
          />
        </template>

        <TransferToRSDescription v-else />

        <div class="signup-form-buttons flex-r">
          <div class="section size-50">
            <div
              class="button"
              @click="emitBackEvent"
            >
              <div class="text">
                Назад
              </div>
            </div>
          </div>

          <div class="section size-50 txt-algn-r">
            <div
              class="button primary"
              :class="{ disabled: !isValidForm }"
              @click="emitNextStepEvent"
            >
              <div class="text">
                Следующий шаг
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section size-10" />
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import holderName from '@/validators/rule/holderName';
import cardNumber from '@/validators/rule/cardNumber';
import cvc from '@/validators/rule/cvc';
import cardMonth from '@/validators/rule/cardMonth';
import cardYear from '@/validators/rule/cardYear';
import PaymentMethod from './PaymentMethod';
import BankCardTypePicker from './BankCardTypePicker';
import BankCardPaymentForm from './BankCardPaymentForm';
import TransferToRSDescription from './TransferToRSDescription';
import cloneDeep from 'lodash.clonedeep';

const PAYMENT_CREDENTIALS_BANK_CARD_TYPES_HANDLE = {
  CORPORATE_CARD: 'CORPORATE_CARD',
  THIRD_PARTY_BANK_CARD: 'THIRD_PARTY_BANK_CARD'
};

const PAYMENT_METHODS_HANDLE = {
  BANK_CARD: 'BANK_CARD',
  TRANSFER_TO_RS: 'TRANSFER_TO_RS'
};

const PAYMENT_METHODS = [
  {
    name: 'Банковская карта',
    description: 'Моментальная он-лайн оплата услуг. Быстро и удобно.',
    handle: PAYMENT_METHODS_HANDLE.BANK_CARD
  },
  {
    name: 'Перевод на Р/C',
    description: 'Более долгий способ, необходима ручная проверка платежей.',
    handle: PAYMENT_METHODS_HANDLE.TRANSFER_TO_RS
  }
];

const PAYMENT_CREDENTIALS_BANK_CARD_TYPES = [
  {
    name: 'Банковская карта',
    description: 'Моментальная он-лайн оплата услуг. Быстро и удобно.',
    handle: PAYMENT_CREDENTIALS_BANK_CARD_TYPES_HANDLE.CORPORATE_CARD
  },
  {
    name: 'Банковскся карта третьего лица',
    description: 'Исполнение обязательства третьим лицом',
    handle: PAYMENT_CREDENTIALS_BANK_CARD_TYPES_HANDLE.THIRD_PARTY_BANK_CARD,
    confirmationCheckbox: {
      text: 'Подтверждаю, что исполняю обязательства ООО «Джаст Резерв» перед ООО «Джаст Резерв», вытекающие из Договора №XXXX от 10.01.2019 на основании п. 1 ст. 294 Гражданского кодекса Республики Беларусь.'
    }
  }
];

export default {
  name: 'PaySubscriptionStep',
  components: {
    PaymentMethod,
    BankCardTypePicker,
    BankCardPaymentForm,
    TransferToRSDescription
  },
  props: {
    creditCard: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      paymentMethods: PAYMENT_METHODS,
      paymentCredentialsBankCardTypes: PAYMENT_CREDENTIALS_BANK_CARD_TYPES,
      paymentMethodsHandle: PAYMENT_METHODS_HANDLE,
      paymentCredentials: {
        method: PAYMENT_METHODS[0].handle,
        bankCardType: PAYMENT_CREDENTIALS_BANK_CARD_TYPES[0].handle,
        isTermsOfPaymentConfirmed: true,
        creditCard: cloneDeep(this.creditCard)
      },
      isValidForm: false
    }
  },
  watch: {
    'paymentCredentials.creditCard'() {
      this.isValidForm = this.$refs.creditCard.isValid();
    }
  },
  methods: {
    setPaymentMethod(paymentMethod) {
      this.paymentCredentials.method = paymentMethod.handle;
    },
    setPaymentCredentialsType(paymentCredentialsBankCardType) {
      this.paymentCredentials.bankCardType = paymentCredentialsBankCardType.handle;

      this.paymentCredentials.isTermsOfPaymentConfirmed = paymentCredentialsBankCardType.confirmationCheckbox === undefined;
    },
    emitNextStepEvent() {
      if (this.isValidForm) {
        if (this.paymentCredentials.method === PAYMENT_METHODS_HANDLE.TRANSFER_TO_RS) {
          this.$emit('next', this.paymentCredentials.method);
        } else if (this.paymentCredentials.isTermsOfPaymentConfirmed) {
          this.$emit('next', {
            method: this.paymentCredentials.method,
            creditCard: this.paymentCredentials.creditCard
          });
        }
      }
    },
    emitBackEvent() {
      this.$emit('back');
    }
  }
}
</script>
